import { createRouter, createWebHistory } from '@ionic/vue-router';
import { filterStore } from '../store/filter';
import { authStore } from '../store/auth';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/CreateAccount.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: '/statistics',
    name: 'StatisticOverview',
    component: () => import('@/views/statistics/StatisticOverview.vue'),
  },
  {
    path: '/settings',
    name: 'UserSettings',
    component: () => import('@/views/UserSettings.vue'),
  },
  {
    path: '/friends',
    name: 'Friends',
    component: () => import('@/views/Friends.vue'),
  },
  {
    path: '/friendstats',
    name: 'FriendStats',
    component: () => import('@/views/FriendStats.vue'),
  },
  {
    path: '/newsession',
    name: 'NewSession',
    component: () => import('@/views/NewSession.vue'),
    handler: () => {
      // console.log("New Session router activated");
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  const useFilterStore = filterStore();
  if (to.name === "FriendStats") useFilterStore.watchFriends = true;
  else useFilterStore.watchFriends = false;
  const useAuthStore = authStore();
  
  console.log(to.name);
  
  setTimeout(() => {
    if (to.name === "Dashboard" && !useAuthStore.user) router.push("/");
    if (to.name === "NewSession" && !useAuthStore.user) router.push("/");
    if (to.name === "FriendStats" && !useAuthStore.user) router.push("/");
    if (to.name === "Friends" && !useAuthStore.user) router.push("/");
    if (to.name === "StatisticOverview" && !useAuthStore.user) router.push("/");
    
    // if (to.name === "Home" && useAuthStore.user) router.push("/");
    // if (to.name === "Register" && useAuthStore.user) router.push("/");
    // if (to.name === "Login" && useAuthStore.user) router.push("/");
  }, 1000);

  // if (from !== to) useAuthStore.authenticate();
  // setTimeout(() => {
    // if (
      // make sure the user is authenticated
      // !useAuthStore.user && to.name !== 'Login' && to.name !== 'Home' && to.name !== 'Register'
    // ) {
      // redirect the user to the login page
      // return { name: 'Home' }
    // }
  // }, 300);
})


export default router
